module.exports = __webpack_public_path__ + "img/works_mixi_xflag_3.3f9ffdb3.png";